function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogsComponent from '@/components/DialogsComponent';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import tasks from '@/js/tasks';
export default {
  name: 'SandboxViewsTabComponent',
  components: {
    DialogsComponent: DialogsComponent
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      INTERBANK_DOMAIN: 'interbank.pe',
      DIALOG_DELETE: 'DIALOG_DELETE',
      viewToDelete: null
    };
  },
  computed: {
    views: function views() {
      var views = [];
      var externalViews = this.item.view_group_ext;
      var internalViews = this.item.view_group_int;
      if (this.item.organization === this.INTERBANK_DOMAIN) {
        externalViews = this.item.view_group_ext_company;
        internalViews = this.item.view_group_int_company;
      }
      views.push.apply(views, _toConsumableArray(Object.values(externalViews)));
      views.push.apply(views, _toConsumableArray(Object.values(internalViews)));
      return views;
    }
  },
  methods: {
    copyViewId: function copyViewId(view) {
      navigator.clipboard.writeText(view);
      this.$toast.info(this.translate('frases.view_id_copied'));
    },
    openDeleteDialog: function openDeleteDialog(view) {
      this.viewToDelete = view;
      this.$refs[this.DIALOG_DELETE].onOpen();
    },
    deleteBase: function deleteBase(confirm) {
      var _this = this;
      //dev-intercorp-data-operation.sand_itcm_test1jr_2705.v_sand_base1
      if (confirm) {
        var view = this.viewToDelete;
        if (!view) return;
        var deleteAttributes = this.item.params.rdetail.filter(function (attribute) {
          return attribute.attribute_view_name == view;
        });
        var setCompanyCodeUsr = deleteAttributes.reduce(function (acc, attribute) {
          acc.add(attribute.company_code_usr);
          return acc;
        }, new Set());
        var setCompanyCode = deleteAttributes.reduce(function (acc, attribute) {
          acc.add(attribute.company_code);
          return acc;
        }, new Set());
        console.log('deleteAttributes', deleteAttributes);
        console.log('setCompanyCodeUsr', setCompanyCodeUsr);
        var newAttributes = this.item.params.rdetail.filter(function (attribute) {
          return attribute.attribute_view_name !== view;
        });
        this.item.params.company_code_usr = _toConsumableArray(setCompanyCodeUsr)[0];
        this.item.params.company_code = _toConsumableArray(setCompanyCode)[0];
        var body = _objectSpread(_objectSpread({
          view: view,
          usecase_id: String(this.item.id)
        }, this.item.params), {}, {
          rdetail: newAttributes
        });
        console.log('body', body);
        UseCasesService.deleteBase(body, this.item.id).then(function () {}).catch(function (error) {
          console.error(error);
        }).finally(function () {
          console.log('Base eliminada - emit update ');
          _this.$emit('update');
          _this.viewToDelete = null;
        });
      }
    }
  }
};